export class Position {
    position: number;
    player: number;
    substitution: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/position.model.ts